<template>
  <el-card>
    <div slot="header">
      <span>Kiszerelések</span>
      <el-button
        style="float: right; margin-top: -8px;"
        type="success"
        size="small"
        icon="el-icon-plus"
        @click="onCreate"
      >
        Új kiszerelés
      </el-button>
    </div>
    <list
      :packTypes="packTypes"
      :showDialog="showDialog"
      :packTypeFormType="packTypeFormType"
      @closeDialog="showDialog = false"
      @openCreateDialog="onOpenCreate"
      @openUpdateDialog="onOpenUpdate"
      @change="onChange"
      @add="onPackTypeCreate"
    />
  </el-card>
</template>

<script>
import List from './PackTypes/List';

export default {
  components: { List },
  props: ['packTypes'],
  data() {
    return {
      showDialog: false,
      packTypeFormType: 'add',
      basicData: {
        ctn: {},
        category: {},
        primary_supplier: {},
        manufacturer: {},
      },
      rules: {
        name: [
          {
            required: true,
            message: 'Név megadása kötelező',
            trigger: 'change'
          }
        ],
      }
    };
  },
  computed: {
    customsTariffNumbers() {
      return this.$store.getters['customsTariffNumber/customsTariffNumbers'];
    },
    manufacturers() {
      return this.$store.getters['manufacturer/manufacturers'];
    },
    suppliers() {
      return this.$store.getters['partner/suppliers'];
    },
    categories() {
      return this.$store.getters['productCategory/productCategories'];
    },
    supplierCategories() {
      return this.$store.getters['supplierCategory/supplierCategories'];
    },
  },
  watch: {
    product(newVal) {
      this.basicData = Object.assign({}, newVal);
    },
  },
  methods: {
    onCreate() {
      this.packTypeFormType = 'add';
      this.showDialog = true;
    },
    onPackTypeCreate(packType) {
      this.$emit('add', {
        ...packType,
        key: Math.random().toString(36).substring(7),
      });
    },
    onChange(packTypes) {
      this.$emit('packTypeChange', packTypes);
    },
    onOpenCreate() {
      this.packTypeFormType = 'add';
      this.showDialog = true;
    },
    onOpenUpdate() {
      this.packTypeFormType = 'update';
      this.showDialog = true;
    },
  },
};
</script>
